/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Standards_Preset_Select_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Event group standards preset" |
*
* @param {Standards_Preset_Select_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const standards_preset_select_aria_label = /** @type {((inputs?: Standards_Preset_Select_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Standards_Preset_Select_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Event group standards preset")
	if (locale === "de") return /** @type {LocalizedString} */ ("Event group standards preset")
	if (locale === "it") return /** @type {LocalizedString} */ ("Event group standards preset")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Event group standards preset")
	if (locale === "es") return /** @type {LocalizedString} */ ("Event group standards preset")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Event group standards preset")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Event group standards preset")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Event group standards preset")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Event group standards preset")
	return /** @type {LocalizedString} */ ("Event group standards preset")
});